module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cKlFL"))).then(() => parcelRequire('d0iPb'));